import { CurrentPayPlan } from '@ace-clublabs/common-membership-api-types';
import StatusCode from 'status-code-enum';

export const CACHED_MEMBERSHIP_STATUS_KEY = 'CACHED_MEMBERSHIP_STATUSES';

export const envMapForJoinUrl: { [env: string]: string } = {
  dev1: 'qamvc',
  dev2: 'qa2mvc',
  qa1: 'qamvc',
  qa2: 'qa2mvc',
  uat1: 'uatmvc',
  uat2: 'uat2mvc',
  prod: 'apps',
};

export const ClubCode = {
  alabama: '001',
  calif: '004',
  hawaii: '018',
  northernnewengland: '036',
  autoclubmo: '065',
  eastcentral: '215',
  texas: '252',
  tidewater: '258',
  newmexico: '601',
  unknown: '000',
};

export const autoPayBillPlans = [
  CurrentPayPlan.RECURRINGCREDITORDEBITCARD,
  CurrentPayPlan.RECURRINGELECTRONICCHECK,
  CurrentPayPlan.RECURRINGMONTHLY,
];

export enum ErrorType {
  CUSTID_PARAM_REQURED = 'customerId parameter required',
}

export enum Pages {
  HomePage = '/',
  SelectMemberPage = '/selectmember',
  MembershipCard = '/membershipcard',
  RequestPlasticCard = '/requestplasticcard',
  Confirmation = '/confirmation',
  SorryPage = '/sorry',
  TimeoutError = '/sorry/timeout',
  MantenancePage = '/maintenance',
}

export enum ExternalCTAs {
  Account = 'https://account.app.ace.aaa.com',
}

export const AUTH_STORAGE_LABEL = 'aceutmembership';
export const AUTH_QUERY_PARAM_NAME = 'query_aceut';

export const SESSION_EXPIRED_STATUS_CODES = [
  StatusCode.ClientErrorForbidden,
  StatusCode.ClientErrorUnauthorized,
  StatusCode.ClientErrorNotFound,
];

// not to be reinstated query params
export const TOKEN_QUERY_PARAM = 'token';
export const MOBILE_APP_QUERY_PARAM = 'mobileapp';
//

/**
 * Persisted query params are saved to session storage via this key
 */
export const QUERY_PARAM_KEY = 'query_params';

/**
 * Persist the mobileapp query param value in session storage
 */
export const MOBILE_APP_QUERY_PARAM_STORAGE_KEY = 'mss_mobileapp_query_param';

export const CAMPAIGN_CODE_QUERY_PARAM = 'campaigncodemr';

export const WHITE_LISTED_QUERY_PARAMS = [
  CAMPAIGN_CODE_QUERY_PARAM,
  'ts',
  'zip',
  'campaigncode',
  'intcmp',
  'jid',
  'cid',
  'custid',
  'qa',
  'area',
  'pmed',
  'click_id',
  'ctadgroup',
  'ctadpos',
  'ctcreative',
  'ctkwd',
  'ctmatch',
  'ctplacement',
  'gclid',
  'MATK',
  'marocid',
  'maropid',
  's_tnt',
  'adobe_mc_sdid',
  'adobe_mc_ref',
];
